<template>
  <div class="bg-darkmode-important" style="background-color: #f5f6fa; border-radius: 0 0 5px 0">
    <div class="flex-1 pr-30">
      <h6 class="strong">{{ $t("text.popup_widget_settings") }}</h6>

      <div class="flex items-center my-15">
        <h6 class="mb-0 mr-20">{{ $t("text.button_text") }}</h6>
        <div class="flex-1">
          <TextField class="block bg-white font-h6 mt-0" v-model="button_text" />
        </div>
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.button_background_color") }}</h6>
        <SelectColor v-model="button_bg_color" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.button_text_color") }}</h6>
        <SelectColor v-model="button_text_color" />
      </div>

      <!-- ////////////////// -->

      <h6 class="strong">{{ $t("text.booking_settings_for_popup") }}</h6>
      <p class="font-body">{{ $t("text.customize_the_booking_page_look") }}</p>

      <div class="my-10 mt-20">
        <Checkbox :label="$t('text.hide_event_details')" :isChecked="s_hide" :labelable="true" @checkboxChange="s_hide = !s_hide" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.background_color") }}</h6>
        <SelectColor v-model="s_bg" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.text_color") }}</h6>
        <SelectColor v-model="s_text" />
      </div>

      <div class="flex items-center my-15">
        <h6 class="mb-0 flex-1">{{ $t("text.button_link_color") }}</h6>
        <SelectColor v-model="s_link" />
      </div>
    </div>
    <div class="flex-1">
      <div class="shadow bg-white mb-20">
        <div class="bg-white bg-white-darkmode align-right p-20">
          <div
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              height: 40px;
              border-radius: 20px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              padding: 0px 20px;
              box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
            "
            :style="{
              color: button_text_color,
              'background-color': button_bg_color,
            }">
            {{ button_text }}
          </div>
        </div>
        <div class="align-right flex items-center items-end p-5 color-lightsteel bg-light">
          <i class="la la-wifi big-text mr-5"></i>
          <i class="la la-calendar big-text mr-5"></i>
          <i class="la la-usb big-text mr-5"></i>
        </div>
      </div>

      <h6 class="strong">{{ $t("text.embed_code") }}</h6>
      <h6>{{ $t("text.place_html_weezly_appear") }}</h6>

      <textarea readonly class="code-display my-15" style="height: 276px; word-break: break-all">{{ htmlCode }}</textarea>

      <div class="align-right">
        <button class="btn btn-primary font-h6" v-ripple @click="copyCode">{{ $t("button.copy_code") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectColor from "@/components/Scheduling/Events/SelectColor";
import { copyClipboard } from "@/helpers/functions.js";
export default {
  name: "SharePopup",
  components: { SelectColor },
  props: {},
  data: function () {
    return {
      button_text: this.$t("button.booking"),
      button_bg_color: "#0090FF",
      button_text_color: "#FFFFFF",

      s_hide: false,
      s_bg: "#FFFFFF",
      s_text: "#000000",
      s_link: "#0090FF",
    };
  },
  computed: {
    settings() {
      return this.$store.getters.getSchedulingSettings;
    },
    htmlCode() {
      return `<!-- ${this.$Brand} popup widget begin -->
<script src="${this.domain}/external/scheduling.js" type="text/javascript" async><\/script>
<script type="text/javascript">window.onload = function() { weezly_CreateBuble('${this.button_text}','${
        this.button_bg_color
      }', '${this.button_text_color}', '${this.external_link}/${this.settings.link}','${
        this.s_hide
      }','${this.s_bg.substring(1)}','${this.s_text.substring(1)}','${this.s_link.substring(1)}') }<\/script>
<!-- ${this.$Brand} popup widget end -->`;
    },
  },
  async mounted() {},
  methods: {
    copyCode() {
      copyClipboard(this.htmlCode);
      this.$root.$emit("alert", this.$t("alert.code_copied"));
    },
  },
};
</script>
